/**
 * Registers `public/sw.js` — the push-only Service Worker (docs/product-planning/PWA-PUSH.md §2).
 * Built bundles only (production and staging); the dev server never gets one, so a stale worker
 * can't interfere with HMR.
 */
export function registerServiceWorker(): void {
  const env = (import.meta as { env?: { PROD?: boolean } }).env;
  if (!env?.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      console.warn('Service worker registration failed', err);
    });
  });
}
